import { Type } from 'class-transformer';

import { IPagination } from './utils';

export class IRegionContactDetail {
  id: number;
  name: string;
  phone: string;
  email: string;
  date: string;
  isActive: number;
  region_id: string | number;
}

export class IRegionContactDetailResponse {
  @Type(() => IRegionContactDetail)
  result: IRegionContactDetail;
}

export class IRegionContactDetailListResponse extends IPagination {
  @Type(() => IRegionContactDetail)
  results: IRegionContactDetail[];
}

export class IRegionContactDetailPostDto {
  name: string;
  phone: string;
  email: string;
  date: string;
  isActive: number;
  regionId: number;
}

export class IRegionContactDetailPatchDto {
  name?: string;
  phone?: string;
  email?: string;
  date?: string;
  isActive?: number;
  regionId?: number;
}
